import { render } from "./ProductsGrid.vue?vue&type=template&id=270379ea&scoped=true"
import script from "./ProductsGrid.vue?vue&type=script&lang=js"
export * from "./ProductsGrid.vue?vue&type=script&lang=js"

import "./ProductsGrid.vue?vue&type=style&index=0&id=270379ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-270379ea"

export default script